import {KTSVG} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {EmbeddingsListFilter} from './EmbeddingsListFilter'
import { useNavigate } from 'react-router-dom';

const EmbeddignsListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddUserModal = () => {
    setItemIdForUpdate(null)
  }
  const navigate = useNavigate();

  const redirectToRoute = () => {
    
    navigate('/websiteWizard'); 
  }// Replace with the actual route you want to redirect to  };

  const redirectToRoutepdf = () => {
    
    navigate('/pdfWizard'); 
  }// Replace with the actual route you want to redirect to  };

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      {/* <UsersListFilter /> */}
            {/* search karo for filer */}
      {/* begin::Export */}
      {/* <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        Export
      </button> */}
      {/* begin::Add user */}
      <button type='button' className='btn btn-primary btn-sm me-2' onClick={redirectToRoutepdf}>
        <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-2' />
        From PDF
      </button>

      <button type='button' className='btn btn-primary btn-sm me-2' onClick={redirectToRoute}>
        <KTSVG path='/media/icons/duotune/general/gen054.svg' className='svg-icon-2' />
        From Website
      </button>
      {/* end::Add user */}
      {/* end::Export */}
      <button type='button' className='btn btn-primary btn-sm ' onClick={openAddUserModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        Add File
      </button>
      
    </div>
  )
}

export {EmbeddignsListToolbar}
